/**
 * OfflineBanner — Slim top-of-viewport bar when the browser is offline.
 *
 * Listens to `online` / `offline` window events.
 * Auto-hides when connectivity returns.
 */

import { useState, useEffect } from "react";
import { WifiOff } from "lucide-react";

export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);

    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      className="bg-slate-800 text-white text-xs text-center py-1.5 px-4 flex items-center justify-center gap-2"
      role="status"
      aria-live="polite"
    >
      <WifiOff className="h-3.5 w-3.5 flex-shrink-0" />
      <span>You appear to be offline. Some features may be unavailable.</span>
    </div>
  );
}
